import * as React from "react"

const SvgNext = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    viewBox="0 0 56 56"
    {...props}
  >
    <g data-name="Ellipse 13" fill="none" stroke="#fff" opacity={0.4}>
      <circle cx={28} cy={28} r={28} stroke="none" />
      <circle cx={28} cy={28} r={27.5} />
    </g>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          data-name="Path 125"
          d="M24.613 35.354c-.32-.118-.527-.3-.5-.632a.624.624 0 0 1 .252-.406q2.185-1.9 4.368-3.793l2.769-2.4a.945.945 0 0 0 .171-.16.886.886 0 0 1-.17-.088l-7.122-6.185a.642.642 0 0 1-.268-.401c-.029-.299.1-.473.5-.646h.3a3.618 3.618 0 0 1 .459.291q3.79 3.282 7.57 6.572c.4.346.4.641 0 .987q-3.783 3.287-7.57 6.572a3.687 3.687 0 0 1-.459.291Z"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
)

export default SvgNext
